module.exports = __webpack_public_path__ + "static/Case-Studies-Aassociate-d14310e7fce9c851706dd2c7b013c105.jpeg";